/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "multipass": {
        "nested": {
          "http": {
            "nested": {
              "StatusResponse": {
                "fields": {
                  "expireTimestamp": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "maxIdleMinutes": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "currentIdleMinutes": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "hasPassword": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "twoFactorProvidedTimestamp": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "requiresTwoFactor": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "currentServerTimestamp": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "canSkipTwoFactorEnroll": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "canUseGoogleAuthenticator": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "canUseSms": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "canUseWebAuthn": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "employmentToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "impersonator": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "canUseVoice": {
                    "type": "bool",
                    "id": 17,
                    "rule": "optional"
                  },
                  "hasMultipleAuthenticationFactors": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional"
                  },
                  "hasEmail": {
                    "type": "bool",
                    "id": 19,
                    "rule": "optional"
                  },
                  "limited": {
                    "type": "bool",
                    "id": 20,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.multipass?.nested?.http?.nested?.StatusResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE StatusResponse @ squareup/multipass/http.proto at 233:1
 */
export const StatusResponse = $root.lookupType('squareup.multipass.http.StatusResponse');
fixType(StatusResponse);
Builder.createAndAttachToType(StatusResponse);